<template>
  <div class="responsive-grid">
    <slot />
  </div>
</template>

<script>
export default {
  name: "ResponsiveGrid",
  props: {
    maxColumns: {
      type: Number,
      default: 4
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.responsive-grid {
  display: grid;
  grid-gap: $space-lg;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-auto-rows: auto;

  @include screen-md {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}
</style>
